// 启动模块上下文

import { createContext, useContext, ReactNode } from "react";
import { useStartupData } from "../stores";
import { startupService } from "../services";
import { useBaseCache } from "../../base/contexts";

// Context类型定义
interface StartupContextType {
  // 启动数据
  startupData: ReturnType<typeof useStartupData>;
  // 启动服务
  startupService: typeof startupService;
  // 基础缓存
  cache: ReturnType<typeof useBaseCache>;
}

// 创建Context
const StartupContext = createContext<StartupContextType | null>(null);

// Provider Props
interface StartupContextProviderProps {
  children: ReactNode;
}

// Provider组件
export function StartupContextProvider({
  children,
}: StartupContextProviderProps) {
  const startupData = useStartupData();
  const cache = useBaseCache();

  const value: StartupContextType = {
    startupData,
    startupService,
    cache,
  };

  return (
    <StartupContext.Provider value={value}>{children}</StartupContext.Provider>
  );
}

// Hook
export function useStartupContext(): StartupContextType {
  const context = useContext(StartupContext);
  if (!context) {
    throw new Error(
      "useStartupContext must be used within StartupContextProvider"
    );
  }
  return context;
}
